/** @format */

import { Table } from "antd";
import { useState } from "react";

type twpType = {
  loading: boolean;
  columns: any;
  dataTable: any[];
  rowKeyField: string;
};

export const TableWithPagination = ({
  loading,
  columns,
  dataTable,
  rowKeyField,
}: twpType) => {
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  return (
    <>
      <Table
        loading={loading}
        columns={columns}
        dataSource={dataTable}
        rowKey={(record) => record?.[rowKeyField]}
        bordered
        pagination={{
          total: dataTable?.length ?? 0,
          position: ["bottomRight"],
          defaultPageSize: pageSize,
          defaultCurrent: page,
          showTotal: (total) => `Total ${total} items`,
          onChange(page, pageSize) {
            setPage(page);
            setPageSize(pageSize);
          },
        }}
      />
    </>
  );
};
